(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('DeclinedDeleteController',DeclinedDeleteController);

    DeclinedDeleteController.$inject = ['$uibModalInstance', 'entity', 'Declined'];

    function DeclinedDeleteController($uibModalInstance, entity, Declined) {
        var vm = this;

        vm.declined = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Declined.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
